import { ReactComponent as ConnectionSvg } from "./connection.svg";
const ConnectionIcon = (props) => {
  return <ConnectionSvg {...props} />;
};
export default ConnectionIcon;
